<div fxFill fxLayout="column" fxLayoutAlign="start">
  <h1 mat-dialog-title>{{ data.title }}</h1>

  <div fxFlex>
    <mat-dialog-content>
      <mat-horizontal-stepper
          #stepper
          (selectionChange)="onStepChange($event)"
          (animationDone)="onStepAnimationDone()"
          disabled="true"
          labelPosition="bottom"
          linear="true"
      >
        <!-- DATI DEBITORE -->
        <mat-step [stepControl]="debtorForm">
          <ng-template matStepLabel>{{ 'DEBTOR.DEBTOR' | translate }}</ng-template>

          <ng-container *ngIf="this.data.action !== 'edit'">
            <form [formGroup]="clientForm">
              <div fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                  <mat-label>{{ 'DEBTOR.SEARCH_CLIENTS' | translate }}</mat-label>
                  <input [matAutocomplete]="auto"
                         formControlName="clientPicker"
                         id="clientPicker"
                         matInput
                         type="text"
                  />
                  <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="autocompleteSelect($event)"
                      [displayWith]="autocompleteDisplay"
                  >
                    <mat-option *ngFor="let debtor of filteredClients" [value]="debtor">
                      {{ autocompleteDisplay(debtor) }}
                    </mat-option>
                  </mat-autocomplete>
                  <button (click)="resetDebtorForm()" mat-icon-button matSuffix>
                    <mat-icon style="height: 24px; width: 24px">close</mat-icon>
                  </button>
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="center center">
                  <button (click)="createNewDebtor()" [disabled]="userMadeAChoice" mat-button>
                    <mat-icon>add</mat-icon>
                    <span>{{ 'DEBTOR.ADD_NEW' | translate }}</span>
                  </button>
                </div>
              </div>
            </form>

            <mat-divider class="my-12"></mat-divider>
          </ng-container>

          <form [formGroup]="debtorForm" style="padding-top: 10px;">
            <ng-container *ngIf="userMadeAChoice || this.data.action === 'edit'">
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px">
                  <mat-form-field fxFlex="50">
                    <mat-label>{{ 'DEBTOR.BUSINESS_NAME' | translate }}</mat-label>
                    <input
                      [errorStateMatcher]="CustomErrorMatcher"
                      formControlName="businessName"
                      id="businessName"
                      matInput
                      required
                      type="text" />
                    <mat-error>
                      <span
                        *ngIf="debtorForm.get('businessName').hasError('required')">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </mat-error>
                  </mat-form-field>

                  <div fxFlex="50" fxLayout="row" fxLayoutGap="10px">
                    <mat-form-field fxFlex="40">
                      <mat-label>{{ 'DEBTOR.TAX_CODE_PREFIX' | translate }}</mat-label>
                      <mat-select formControlName="taxCodePrefix" required>
                        <mat-option
                          *ngFor="let code of taxCodeDataService.taxCode"
                          [value]="code.value">
                          {{ code.country }} - {{ code.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field fxFlex="60">
                      <mat-label>{{ 'DEBTOR.TAX_CODE' | translate }}*</mat-label>
                      <span
                        [class.disabled-text]="debtorForm.get('taxCode').disabled"
                        matPrefix
                        style="padding-right: 5px">
                        {{ debtorForm.get('taxCodePrefix').value }}
                      </span>
                      <input formControlName="taxCode" id="taxCode" matInput type="text" />
                      <mat-error>
                        <div *ngIf="debtorForm.get('taxCode').hasError('required')">
                          {{ 'ERROR.REQUIRED' | translate }}
                        </div>
                        <div *ngIf="debtorForm.hasError('taxCodeInvalid')">
                          {{ 'ERROR.TAX_CODE.INVALID' | translate }}
                        </div>
                        <span *ngIf="debtorForm.get('taxCode').hasError('length')">{{
                                'ERROR.TAX_CODE.FORMAT' | translate
                          }}</span>
                        <span *ngIf="debtorForm.get('taxCode').hasError('pattern')">{{
                                'ERROR.TAX_CODE.FORMAT' | translate
                          }}</span>
                        <span *ngIf="debtorForm.get('taxCode').hasError('checksum')">{{
                                'ERROR.TAX_CODE.FORMAT' | translate
                          }}</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <ng-container *ngIf="showDebtorContactData">

                  <mat-divider class="my-12"></mat-divider>

                  <h3>{{ 'DEBTOR.CONTACT_DATA' | translate }}</h3>

                  <div fxLayout="row" fxLayoutGap="10px">
                    <mat-form-field fxFlex="50">
                      <mat-label>{{ 'DEBTOR.FIRST_NAME' | translate }}</mat-label>
                      <input
                        [errorStateMatcher]="CustomErrorMatcher"
                        formControlName="contactFirstName"
                        id="contactFirstName"
                        matInput
                        required
                        type="text"
                      />
                      <mat-error>
                      <span *ngIf="debtorForm.get('contactFirstName').hasError('required')">{{
                              'ERROR.REQUIRED' | translate
                        }}</span>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex="50">
                      <mat-label>{{ 'DEBTOR.LAST_NAME' | translate }}</mat-label>
                      <input
                        [errorStateMatcher]="CustomErrorMatcher"
                        formControlName="contactLastName"
                        id="contactLastName"
                        matInput
                        required
                        type="text"
                      />
                      <mat-error>
                      <span *ngIf="debtorForm.get('contactLastName').hasError('required')">{{
                              'ERROR.REQUIRED' | translate
                        }}</span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div fxLayout="row" fxLayoutGap="10px">
                    <mat-form-field fxFlex="50">
                      <mat-label>{{ 'DEBTOR.EMAIL' | translate }}</mat-label>
                      <input
                        [errorStateMatcher]="CustomErrorMatcher"
                        formControlName="contactEmail"
                        id="contactEmail"
                        matInput
                        required
                        type="text"
                      />
                      <mat-error>
                      <span *ngIf="debtorForm.get('contactEmail').hasError('required')">{{
                              'ERROR.REQUIRED' | translate
                        }}</span>
                        <span *ngIf="debtorForm.get('contactEmail').hasError('email')">{{
                                'ERROR.EMAIL' | translate
                          }}</span>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex="50">
                      <mat-label>{{ 'DEBTOR.PHONE' | translate }}</mat-label>
                      <input
                        [errorStateMatcher]="CustomErrorMatcher"
                        formControlName="contactPhone"
                        id="contactPhone"
                        matInput
                        required
                        type="text"
                      />
                      <mat-error>
                      <span *ngIf="debtorForm.get('contactPhone').hasError('required')">{{
                              'ERROR.REQUIRED' | translate
                        }}</span>
                        <span *ngIf="debtorForm.get('contactPhone').hasError('pattern')">{{
                                'ERROR.PHONE' | translate
                          }}</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </form>
        </mat-step>

        <!-- DATI FATTURA -->
        <mat-step [stepControl]="invoiceForm">
          <ng-template matStepLabel>{{ 'INVOICE.INVOICE' | translate }}</ng-template>
          <form [formGroup]="invoiceForm" style="padding-top: 10px;">
            <div fxLayout="row">
              <mat-form-field fxFlex>
                <mat-label>{{ 'INVOICE.NUMBER' | translate }}</mat-label>
                <input
                  [errorStateMatcher]="CustomErrorMatcher"
                  formControlName="number"
                  id="number"
                  matInput
                  required
                  type="text"
                />
                <mat-error>
                  <span *ngIf="invoiceForm.get('number').hasError('required')">{{
                          'ERROR.REQUIRED' | translate
                    }}</span>
                </mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="10px">
              <mat-form-field fxFlex="50">
                <mat-label>{{ 'INVOICE.INVOICE_DATE' | translate }}</mat-label>
                <input
                  (click)="issueDatePicker.open()"
                  [errorStateMatcher]="CustomErrorMatcher"
                  [matDatepicker]="issueDatePicker"
                  [max]="today"
                  formControlName="issueDate"
                  id="issueDate"
                  matInput
                  required
                />
                <mat-datepicker-toggle
                  [for]="issueDatePicker"
                  matSuffix
                  tabIndex="-1"
                ></mat-datepicker-toggle>
                <mat-datepicker #issueDatePicker></mat-datepicker>
                <mat-error *ngIf="invoiceForm.get('issueDate').invalid">
                  <ng-container
                    *ngIf="invoiceForm.get('issueDate').hasError('required'); else invalid"
                  >
                    <span>{{ 'ERROR.REQUIRED' | translate }}</span>
                  </ng-container>
                  <ng-template #invalid>
                    <span>{{ 'ERROR.DATE' | translate }}</span>
                  </ng-template>
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="50">
                <mat-label>{{ 'INVOICE.DUE_DATE' | translate }}</mat-label>
                <input
                  (click)="dueDatePicker.open()"
                  [errorStateMatcher]="CustomErrorMatcher"
                  [matDatepicker]="dueDatePicker"
                  [min]="theDayAfterTomorrow"
                  formControlName="dueDate"
                  id="dueDate"
                  matInput
                  required
                />
                <mat-datepicker-toggle
                  [for]="dueDatePicker"
                  matSuffix
                  tabIndex="-1"
                ></mat-datepicker-toggle>
                <mat-datepicker #dueDatePicker></mat-datepicker>
                <mat-error *ngIf="invoiceForm.get('dueDate').invalid">
                  <ng-container
                    *ngIf="invoiceForm.get('dueDate').hasError('required'); else invalidDueDate"
                  >
                    <span>{{ 'ERROR.REQUIRED' | translate }}</span>
                  </ng-container>
                  <ng-template #invalidDueDate>
                    <span>{{ 'ERROR.DATE' | translate }}</span>
                  </ng-template>
                </mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="10px">
              <mat-form-field fxFlex="100">
                <mat-label>{{ 'INVOICE.AMOUNT' | translate }}</mat-label>
                <input
                    #amount
                    [errorStateMatcher]="CustomErrorMatcher"
                    class="autonumeric"
                    formControlName="amount"
                    id="amount"
                    matInput
                    required
                />
                <mat-icon class="secondary-text" matSuffix>euro_symbol</mat-icon>
                <mat-error>
                  <span *ngIf="invoiceForm.get('amount').hasError('required')">{{
                          'ERROR.REQUIRED' | translate
                    }}</span>
                </mat-error>
              </mat-form-field>
            </div>

            <div *ngIf="isInvoiceFromXml() && invoiceInstallments && invoiceInstallments.length > 0">
              <h3 style="margin-bottom: 16px;">{{ 'INVOICE.INSTALLMENTS' | translate }}</h3>
              <mat-table [dataSource]="invoiceInstallments" class="custom-table">
                <ng-container matColumnDef="installmentNumber">
                  <mat-header-cell *matHeaderCellDef fxFlex="120px" fxLayoutAlign="start center">
                    {{ 'INVOICE.INSTALLMENT_NUMBER' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let installment; let index = index" fxFlex="120px" fxLayoutAlign="start center">
                    {{ index + 1 }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="amount">
                  <mat-header-cell *matHeaderCellDef fxLayoutAlign="end center">
                    {{ 'INVOICE.AMOUNT' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let installment" fxLayoutAlign="end center">
                    {{ installment.amount | currency: 'EUR' }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="dueDate">
                  <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center">
                    {{ 'INVOICE.DUE_DATE' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let installment" fxLayoutAlign="center center">
                    {{ installment.dueDate | dateFormat }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            </div>
          </form>
        </mat-step>

        <!-- DATI ASTA -->
        <mat-step [stepControl]="auditionForm">
          <ng-template matStepLabel>{{ 'AUCTION.AUCTION' | translate }}</ng-template>
          <form [formGroup]="auditionForm" style="padding-top: 10px;">
            <div fxLayout="column">
              <mat-form-field>
                <mat-label>{{ 'AUCTION.DAY_DELAY' | translate }}</mat-label>
                <input
                  [errorStateMatcher]="CustomErrorMatcher"
                  formControlName="averagePaymentDelay"
                  id="averagePaymentDelay"
                  matInput
                  required
                  type="number"
                />
                <mat-hint>{{ 'AUCTION.DAY_DELAY_HINT' | translate }}</mat-hint>
                <mat-error>
                  <ng-container *ngIf="auditionForm.get('averagePaymentDelay').hasError('required')">
                    <span>{{ 'ERROR.REQUIRED' | translate }}</span>
                  </ng-container>
                  <ng-container *ngIf="auditionForm.get('averagePaymentDelay').hasError('pattern')">
                    <span>{{ 'ERROR.INVALID' | translate }}</span>
                  </ng-container>
                </mat-error>
              </mat-form-field>

              <p>{{ 'AUCTION.SELL_INFO' | translate }}</p>

              <p>
                {{ 'AUCTION.RANGE_INFO' | translate }} {{ priceMin | currency: 'EUR' }}
                {{ 'AUCTION.AND' | translate }} {{ priceMax | currency: 'EUR' }}
              </p>

              <div fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex="100">
                  <mat-label>{{ 'AUCTION.MINIMUM_BID' | translate }}</mat-label>
                  <input
                      #minimumBidRef
                      [errorStateMatcher]="CustomErrorMatcher"
                      formControlName="minimumBid"
                      id="minimumBid"
                      matInput
                      required
                      type="number"
                  />
                  <mat-icon class="secondary-text" matSuffix>euro_symbol</mat-icon>
                  <mat-hint
                  >{{ 'AUCTION.VALUE_HINT' | translate }}:
                    {{ priceSuggested | currency: 'EUR' }}
                  </mat-hint
                  >
                  <mat-error *ngIf="auditionForm.get('minimumBid').invalid">
                    <span *ngIf="auditionForm.get('minimumBid').hasError('required')">{{
                            'ERROR.REQUIRED' | translate
                      }}</span>
                    <span
                      *ngIf="
                        auditionForm.get('minimumBid').hasError('min') ||
                        auditionForm.get('minimumBid').hasError('max')
                      "
                    >
                      {{ 'ERROR.MINIMUM_BID_1' | translate }} {{ priceMin | currency: 'EUR' }}
                      {{ 'ERROR.MINIMUM_BID_2' | translate }} {{ priceMax | currency: 'EUR' }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayoutGap="10px" style="margin-top: 10px">
                <div class="mat-primary" fxFlex="100">
                  {{ 'AUCTION.DISCOUNT_APPLIED' | translate }}:
                  <span *ngIf="auditionForm.get('minimumBid').valid">{{ minimumBidDiscount | number: '1.0-2' }}%</span>
                </div>
              </div>
            </div>

            <mat-divider class="my-24" *ngIf="invoiceCreateOrUpdateErrorMessage"></mat-divider>

            <p *ngIf="invoiceCreateOrUpdateErrorMessage" class="orange-700-fg">
              <span style="font-style: italic">{{ invoiceCreateOrUpdateErrorMessage }}</span>
            </p>
          </form>
        </mat-step>

        <!-- ALTRI DOCUMENTI -->
        <mat-step [stepControl]="otherForm">
          <ng-template matStepLabel>{{ 'OTHER_DOC.OTHER_DOC' | translate }}</ng-template>

          <div fxLayout="column" fxLayoutAlign="none" style="padding-top: 10px;">
            <div class="h2">{{ 'INVOICE.INVOICE_PDF' | translate }}:</div>
            <div fxLayout="column" fxLayoutGap="6px" style="margin: 30px 0">
              <div fxLayout="row" fxLayoutGap="10px">
                <ng-container *ngIf="data.action === 'edit' && invoice.fileKey; else newInvoice">
                  <ng-container *ngIf="!invoiceFileName">
                    <div>
                      <button
                        (click)="viewInvoice(invoice.uuid)"
                        mat-raised-button
                        style="background: rgba(0,0,0,.03)"
                      >
                        {{ 'INVOICE.DOWNLOAD_INVOICE' | translate }}
                      </button>
                    </div>
                  </ng-container>
                  <div>
                    <input
                        #fileInput
                        (change)="onInvoiceFileChange($event)"
                        accept=".pdf,.xml"
                        hidden
                        type="file"
                    />
                    <button (click)="fileInput.click()" color="accent" mat-raised-button>
                      {{ 'INVOICE.REPLACE_INVOICE' | translate }}
                    </button>
                  </div>
                  <div fxLayoutAlign="start center" style="padding-left: 10px;">
                    {{ invoiceFileName }}
                  </div>
                </ng-container>

                <ng-template #newInvoice>
                  <div>
                    <input
                        #fileInput
                        (change)="onInvoiceFileChange($event)"
                        accept=".pdf,.xml"
                        hidden
                        type="file"
                    />
                    <button (click)="fileInput.click()" color="accent" mat-raised-button>
                      {{ 'INVOICE.UPLOAD_INVOICE' | translate }}<sup>*</sup>
                    </button>
                  </div>
                  <div fxLayoutAlign="start center" style="padding-left: 10px;">
                    {{ invoiceFileName }}
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="h2">{{ 'OTHER_DOC.LOAD_DOC' | translate }}:</div>
            <div fxLayout="column" style="margin: 20px 0">
              <ng-container *ngFor="let file of invoiceFiles">
                <div class="h-50"
                     fxLayout="row"
                     fxLayoutAlign="space-between center"
                     fxLayoutGap="8px">
                  <mat-icon fxFlex="24px">arrow_right</mat-icon>

                  <div fxFlex="230px">
                    <span>{{ 'OTHER_DOC.' + file.attachmentType | translate }}</span>
                    <ng-container *ngIf="file.attachmentType === AttachmentType.other && file.otherDocumentNotes">
                      <span>&nbsp;-&nbsp;{{ file.otherDocumentNotes }}</span>
                    </ng-container>
                  </div>

                  <div class="text-truncate" fxFlex fxLayoutAlign="end" style="padding-right: 8px">
                    <a (click)="viewAttachment(invoice.uuid, file.id)" style="cursor: pointer">
                      <span>{{ file.name }}</span>
                    </a>
                  </div>

                  <ng-container *ngIf="
                                  file.attachmentType === AttachmentType.client_ledger &&
                                  file.expirationDate &&
                                  isExpired(file.expirationDate)">
                    <mat-icon class="orange-700-fg"
                              [matTooltip]="'OTHER_DOC.EXPIRATION_DATE_WARNING' | translate">warning
                    </mat-icon>
                  </ng-container>

                  <input #fileInputEditAttachment
                         (change)="editAttachment($event, file.id)"
                         [accept]="file.attachmentType === AttachmentType.xml_invoice ? '.xml' : ''"
                         hidden
                         type="file" />
                  <button (click)="fileInputEditAttachment.click()" mat-icon-button
                          [disabled]="file.attachmentType === AttachmentType.xml_invoice && isInvoiceFromXml()">
                    <mat-icon>cloud_upload</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>

            <div>
              <span style="font-style: italic">{{ 'OTHER_DOC.MAX_FILE_SIZE' | translate }}</span>
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions align="end">
    <button *ngIf="stepper.selectedIndex !== 3"
            [disabled]="creatingInvoice"
            [mat-dialog-close]="{refresh: false, publish: false}"
            color="warn"
            mat-button>
      <span>{{ 'ACTION.CANCEL' | translate }}</span>
    </button>

    <span fxFlex *ngIf="stepper.selectedIndex !== 3"></span>

    <button (click)="goBack()"
            *ngIf="stepper.selectedIndex !== 3 && stepper.selectedIndex !== 0"
            [disabled]="creatingInvoice"
            mat-button>
      <span>{{ 'ACTION.PREVIOUS' | translate }}</span>
    </button>

    <button (click)="goForward()"
            *ngIf="stepper.selectedIndex !== 3"
            [disabled]="
        (debtorForm.invalid && stepper.selectedIndex === 0) ||
        (invoiceForm.invalid && stepper.selectedIndex === 1) ||
        (auditionForm.invalid && stepper.selectedIndex === 2) ||
        invoiceCreateOrUpdateErrorMessage !== null ||
        creatingInvoice
      "
            class="btn-next"
            color="accent"
            fxLayoutAlign="center center"
            mat-button>
      <span *ngIf="!creatingInvoice">
        <ng-container *ngIf="stepper.selectedIndex === 2 && data.action === 'edit'; else nextBtn">
          {{ 'ACTION.SAVE' | translate }}
        </ng-container>
        <ng-template #nextBtn> {{ 'ACTION.NEXT' | translate }} </ng-template>
      </span>
      <span *ngIf="creatingInvoice">
        <mat-progress-spinner
          [diameter]="18"
          color="primary"
          mode="indeterminate"
        ></mat-progress-spinner>
      </span>
    </button>

    <ng-container *ngIf="stepper.selectedIndex === 3">
      <div fxLayout="row" style="width: 100%">
        <div class="orange-700-fg" fxFlex="60">
          <span>*{{ 'ACTION.CONTINUES_LATER_INFO' | translate }}&nbsp;<b>{{ 'ACTION.CONTINUES_LATER' | translate }}</b></span>
        </div>

        <span fxFlex></span>

        <button [disabled]="uploadingAttachment"
                [mat-dialog-close]="{refresh: true, publish: false}"
                mat-button>
          <span>{{ 'ACTION.CONTINUES_LATER' | translate }}</span>
        </button>

        <button (click)="closeDialog()"
                [disabled]="uploadingAttachment || isPublishButtonDisabled()"
                class="btn-next green-200"
                color="accent"
                fxLayoutAlign="center center"
                mat-button>
          <ng-container *ngIf="!uploadingAttachment">
            <div fxLayoutAlign="center center">
              <mat-icon>send</mat-icon>
              <span>&nbsp;</span>
              <span>{{ 'ACTION.SEND' | translate }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="uploadingAttachment">
            <mat-progress-spinner
              [diameter]="18"
              color="primary"
              mode="indeterminate"></mat-progress-spinner>
          </ng-container>
        </button>
      </div>

    </ng-container>

  </mat-dialog-actions>
</div>
